module.exports = __webpack_public_path__ + "static/img/bigbackground.0c8ef66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bigbackground.png
// module id = a/ie
// module chunks = 1